export default __webpack_public_path__ + "static/media/settings_icon_bold.78b357a4.svg";